import React from 'react'
import {styled} from '@mui/material/styles'
import { Stack, TextField } from "@mui/material";
import { DateTimePicker } from '@mui/x-date-pickers';
import { format, isValid } from 'date-fns';
import { withStyles } from '@mui/material';

const MuiPickerForCardModals = ({openModal2023, setOpenModal2023}) => {

    return(
        <Stack spacing={4} sx={{width: '200px'}}>
            <DateTimePicker
                InputProps={{style: {fontSize: '12px', height: '40px', outline: 'none'}}}
                label='Date/Time Picker' 
                renderInput={(params) => <TextField {...params} />} 
                value={openModal2023.todoDueDate}
                onChange={(e) => setOpenModal2023(prev => ({...prev, todoDueDate: e.toISOString()}))}
            />
        </Stack>
    )
}
export default MuiPickerForCardModals;